module.exports = __webpack_public_path__ + "static/media/windChimes4.6f08fead.mp3";